module.exports = __webpack_public_path__ + "static/media/location-icon.b2f804bd.svg";